<template>
  <div>
    <loading :active="isLoading" :can-cancel="false" :is-full-page="true" />
    <v-snackbar v-model="snackbar" :top="snackbar.position === 'top'" :location="'top'" :multi-line="false"
      :timeout="6000" :vertical="false">
      {{ snackbarText }}
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false">Close</v-btn>         
      </template>
    </v-snackbar>
    <v-card prepend-icon="mdi-cog" style="padding-right: 0px;">
      <template v-slot:title>
        <h3 class="text-black">Settings</h3>
      </template>
    </v-card>

    <v-divider />
    <v-layout row>
      <v-col col="12" style="padding: 0px;">
        <v-card>
          <v-card-title class="padding_bottom_0">
            <h3 class="text-black">Auto Approve</h3>
          </v-card-title>
          <v-card-text class="padding_bottom_0">
            <p class="text-lg-left">
              Auto approve will skip the pending queue and will automatically approve the transactions.
              Select user(s) for which you would like auto approval.
            </p>
            <span class="position_right" mt="10">
              <v-btn color="success" @click="saveUsers()">Save</v-btn>
            </span>
          </v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" label="Search User" variant="underlined" color="primary">
                <template v-slot:append-inner>
                  <v-icon icon="mdi-magnify"></v-icon>
                </template>
              </v-text-field>
            </v-card-title>
            <v-data-table v-model:sort-by="sortBy" :headers="headers" :items="users" :items-per-page="10"
              class="elevation-1" :search="search" :no-results-text="`Your search for ${search} found no results.`"
              no-data-text="Sorry, nothing to display here." ref="datatable">
              <template v-slot:item.AutoApproveOrder="{ item }">
                <v-checkbox-btn v-model="item.AutoApproveOrder" />
              </template>
              <template v-slot:item.AutoApproveBooking="{ item }">
                <v-checkbox-btn v-model="item.AutoApproveBooking" />
              </template>
              <template v-slot:item.AutoApprovePrepay="{ item }">
                <v-checkbox-btn v-model="item.AutoApprovePrepay" />
              </template>
              <template v-slot:no-data>Sorry, nothing to display here.</template>
            </v-data-table>
            <br />
            <br />
          </v-card>
        </v-card>
      </v-col>
    </v-layout>

  </div>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import DataService from '@/services/data-service';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

const dataService = new DataService();
export default {
  name: 'settings',
  data: () => ({
    snackbar: false,
    expanded: 0,
    snackbarText: '',
    search: '',
    searchText: '',
    searchUsers: [],
    users: [],
    isLoading: false,
    sortBy: [{ key: 'UserDescription', order: 'asc' }],
    // refreshTime: '',

    // Active: true
    // AssignedUserId: "111"
    // AutoApproveBooking: false
    // AutoApproveOrder: false
    // AutoApprovePrepay: false
    // ModifiedDate: "2023-12-06T10:28:36.087"
    // ReferenceId: 5265
    // UserDescription: "RAPIDS"
    // UserId: "6  "


    headers: [
      { title: 'User Id', key: 'AssignedUserId', width: "10%" },
      { title: 'Description', key: 'UserDescription', width: "40%" },
      { title: 'Orders', key: 'AutoApproveOrder', sortable: false },
      { title: 'Bookings (Beta) ', key: 'AutoApproveBooking', sortable: false },
      { title: 'Prepays (Beta)', key: 'AutoApprovePrepay', sortable: false }
    ]
  }),
  created() {
    this.refreshList();
    this.initilize();
  },
  components: {
    Loading,
  },
  methods: {
    initilize() {
      // this.refreshTime = localStorage.getItem('UserRefreshTime');
      this.isLoading = true;
      // this.expanded = localStorage.getItem('enablefilter') === 'true' ? 1 : 0;
      this.expanded = 1;
      dataService.GetUserPermissions().then((response) => {
        this.users = response;
        this.isLoading = false;
        this.searchUsers = Object.assign([], this.users);
      });
    },
    cancel() {
      this.expanded = 1;
    },
    filterChange() {
      localStorage.setItem('enablefilter', this.expanded);
    },
    saveUsers() {
      // const isFiltered = this.users.filter(user => user.Active === false).length > 0;
      // localStorage.setItem("isFiltered", isFiltered);
      dataService
        .UpdateUserPermissions(this.users)
        .then((response) => {
          this.snackbar = true;
          this.snackbarText = 'Settings saved successfully';
        })
        .catch((e) => {
          this.snackbar = true;
          this.snackbarText = 'Settings saved failed';
        });
    },
    refreshList() {
      this.isLoading = true;
      dataService
        .SetUserPrefrences()
        .then(() => {
          this.isLoading = false;
          this.initilize();
        })
        .catch((e) => {
          this.isLoading = false;
          console.log(e, 'Error SetUserPrefrences');
        });
    },
    selectAll() {
      this.searchUsers.forEach((user) => {
        user.Active = true;
      });
    },
    unselectAll() {
      this.searchUsers.forEach((user) => {
        user.Active = false;
      });
    },
    // search() {
    //   this.searchUsers = Object.assign([], this.users);
    //   this.searchUsers = this.searchUsers.filter((user) => {
    //     const srch = this.searchText;
    //     return (
    //       user.AssignedUserID.toLowerCase().indexOf(srch.toLowerCase()) !==
    //         -1 ||
    //       user.UserDescription.toLowerCase().indexOf(srch.toLowerCase()) !== -1
    //     );
    //   });
    // },
  },
};
</script>

<style>
.padding_left_20 {
  padding-left: 12px;
}

.padding_10 {
  padding: 10px;
}

.v-list {
  height: 400px;
  overflow-y: auto;
}

.text_right {
  text-align: right;
}

.position_right {
  right: 125px;
  position: absolute;
  top: 20px !important;
}

.v-expansion-panel__header {
  background-color: white;
}

.swtich {
  position: absolute;
  top: -8px;
  right: 57px;
  z-index: 1000;
}

.padding_bottom_0 {
  padding-bottom: 0px;
}

.mdi-checkbox-marked {
  color: #2196F3 !important;
}

.theme--light.v-table thead th {
  color: rgba(0, 0, 0, .54);
}

.theme--light.v-datatable thead th.column.sortable.active,
.theme--light.v-datatable thead th.column.sortable.active .v-icon,
.theme--light.v-datatable thead th.column.sortable:hover {
  color: rgba(0, 0, 0, .87);
}

.v-card-item__prepend {
  padding: 0px !important;
}
</style>
